import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function AboutUs() {
  return (
    <>
      <Helmet>
        <title>WebsiteSEO</title>
        <meta name="description" content={"Website SEO"} />
        <meta name="keywords" content={"Website SEO  "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/about-us.html"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>About Us</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>About Us</li>
      </ul>
    </div>
  </div>
  {/* CONTACTS
              ============================================= */}
  {/* TEXT CONTENT
  ============================================= */}
  <section className=" ct-01 content-section division py-100">
    <div className="container">
      {/* CONTENT WRAPPER */}
      <div className="row d-flex align-items-center">
        {/* IMAGE BLOCK */}
        <div className="col-lg-7 order-last order-lg-2">
          <div className="img-block left-column wow animate__animated animate__fadeInRight">
            <img className="img-fluid lt-img" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/a7a70d0f-9710-421e-e743-db7a85755200/w=1920,sharpen=1" alt="content-image" />
          </div>
        </div>
        {/* TEXT BLOCK */}
        <div className="col-lg-5 order-first order-lg-2">
          <div className="txt-block right-column wow animate__animated animate__fadeInLeft">
            {/* Module Subtitle */}
            <span className="module-subtitle subtitle-line">About us</span>
            {/* Title */}
            <h2 className="fs-46">Know about story</h2>
            {/* Text */}
            <p>
              We would like to introduce ourselves as a leading media agency Dubai, ace digital marketer, and professional service provider of web designing Dubai, web site hosting, mobile website development, social media optimization, ecommerce website development, Dubai CMS development, etc.
              <br />
              We are already known in the market as a top-notch service provider with expertise and complete command over creativity, cost efficiency, and credibility. We are known as WebsiteSEO.ae not because that we have chosen the name. At WebsiteSEO.ae, weuse creativity in its advanced and upgraded state so that our clients can always stay ahead of the curve.
              <br />
              We are based at Dubai, but we have our network expanded all over the world,with special focus on UAE, INDIA, USA, UK, Australia, KSA, Hong Kong, Qatar, Kuwait, Singapore and Bahrain market. We are ambitious and known as star performers not because of our size and our business credibility; because we think big and we help our clients in achieving big!!
            </p>
          </div>
        </div>	{/* END TEXT BLOCK */}
      </div>   {/* END CONTENT WRAPPER */}
    </div>	   {/* End container */}
  </section>	{/* END TEXT CONTENT */}
  <section className="py-100 about-2 about-section division" style={{backgroundColor: '#f8f8f8'}}>
    <div className="container">
      {/* ABOUT TITLE */}
      <div className="row">
        <div className="col">
          <div className="about-2-title">
            <h4 className="fs-32">How we Work</h4>
          </div>
        </div>
      </div>
      {/* ABOUT TEXT */}
      <div className="row">
        {/* ABOUT TEXT */}
        <div className="col-lg-6">
          <div id="a2-1" className="txt-block left-column wow animate__ animate__fadeInUp animate__delay-1 animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
            {/* Text */}
            <p>
              We work in a flexible way to offer our clients the best mileage in related and specific business niche so that our clients can enjoy best ROI: Our work process is simple and 100% realistic.
              <br />
              We understand your business and we identify your needs. We love to know about your business and your ideas of developing the business for further expansion. We like to place ourselves in your shoe and then we decide our next move.
              <br />
              We identify the market and coordinate with you regarding the best business strategy for development and implement our servicesin the best possible manner.
            </p>
            <p />
          </div>
        </div>	{/* END ABOUT TEXT */}
        {/* ABOUT TEXT */}
        <div className="col-lg-6">
          <div id="a2-2" className="txt-block right-column wow animate__ animate__fadeInUp animate__delay-2 animated" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
            {/* Text */}
            <ul className="simple-list">
              <li className="list-item">
                <p> Innovative design done by our best designers: We offer the service of best web designing services in Dubai</p>
              </li>
              <li className="list-item">
                <p>Integrating cutting edge technology across all our services: We can infuse technology and happy user experience because we believe simplicity is the root of organic beauty.</p>
              </li>
              <li className="list-item">
                <p>Spreading the business message across for offering best brand management: We use best SEOtools, mobile apps development service, content marketing service and social media optimization to spread your business message across the world.</p>
              </li>
              <li className="list-item">
                <p>
                  Getting the job coordinated and done in meteoric speed and with flawless consistency: we love to be perfect in our business output and we love to race with time.
                </p>
              </li>
              <li className="list-item">
                <p className="mb-0">
                  Sodales dapibus libero suscipit quisque congue tempus ociis posuere
                  blandit and tristique mollis lectus hendrerit
                </p>
              </li>
            </ul>
          </div>
        </div>	{/* END ABOUT TEXT */}
      </div>   {/* END ABOUT TEXT */}
    </div>	   {/* End container */}
  </section>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default AboutUs;
